enum MovieLayerType {
  Image = 'Image',
  Shape = 'Shape',
  Video = 'Video',
  Text = 'Text',
  PreComp = 'Precomp',
  Null = 'Null',
  Widget = 'Widget',
  Audio = 'Audio',
}

enum MovieShapeLayerType {
  Rectangle = 'rectangle',
  Ellipse = 'ellipse',
  Polystar = 'polystar',
  Path = 'path',
  TrimPath = 'trimpath',
  MergePath = 'mergepath',
}

enum MovieFillType {
  Solid = 0,
  LinearGradient = 1,
  RadialGradient = 2,
}

enum MovieFontStyle {
  Regular = 'Regular',
  Italic = 'Italic',
}

enum MovieAlign {
  Left = 'Left',
  Right = 'Right',
  Center = 'Center',
  Top = 'Top',
  Bottom = 'Bottom',
}

enum MovieLayerEffectType {
  Mask = 'mask',
  Shadow = 'shadow',
  Fill = 'fill',
  BoxBlur = 'boxBlur',
  ColorOverlay = 'colOver',
  TrkMatte = 'trkmatte',
}

enum MovieBoxBlurDimension {
  Both = 1,
  Horizontal = 2,
  Vertical = 3,
}

enum MovieMaskType {
  Add = 1,
  Subtruct = 2,
  Intersect = 3,
}

enum MovieStrokeType {
  Center = 0,
  Inside = 1,
  Outside = 2,
}

enum MovieLineJoin {
  Miter = 1,
  Round = 2,
  Bevel = 3,
}

enum MovieLineCap {
  Butt = 1,
  Round = 2,
  Square = 3,
}

enum MovieResizeOption {
  NoResize = 5,
  Bars = 3,
  Crop = 4,
}

enum VerticalAlignment {
  Center = 1,
  Top = 2,
  Bottom = 3,
}

enum HorizontalAlignment {
  Center = 1,
  Left = 2,
  Right = 3,
}

enum AnimatorRangeUnit {
  Percent = 1,
  Index = 2,
}

enum AnimatorRangeBase {
  Char = 1,
  CharWithoutSpace = 2,
  Word = 3,
  Line = 4,
}

enum AiAnimatorRangeBase {
  Char = 'Char',
  CharWithoutSpace = 'CharWithoutSpace',
  Word = 'Word',
  Line = 'Line',
}

enum MovieTrackmateType {
  Alpha = 5,
  AlphaInverted = 6,
}

export {
  MovieLayerType,
  MovieFillType,
  MovieShapeLayerType,
  MovieFontStyle,
  MovieAlign,
  MovieLayerEffectType,
  MovieMaskType,
  MovieStrokeType,
  MovieLineJoin,
  MovieLineCap,
  MovieResizeOption,
  MovieBoxBlurDimension,
  AnimatorRangeUnit,
  AnimatorRangeBase,
  AiAnimatorRangeBase,
  MovieTrackmateType,
  HorizontalAlignment,
  VerticalAlignment,
};
